// スクロール監視と画像フェードイン機能
document.addEventListener('DOMContentLoaded', function() {
    // Intersection Observer の設定
    const observerOptions = {
        root: null,
        rootMargin: '-20% 0px -20% 0px', // 画面の中央付近でトリガー
        threshold: 0.3
    };

    // 各セクションのブロックを監視
    const scrollSections = document.querySelectorAll('.scroll-section');
    
    scrollSections.forEach(section => {
        const blocks = section.querySelectorAll('.block');
        const images = section.querySelectorAll('.section-image');

        // ブロックの監視
        const blockObserver = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    const block = entry.target;
                    const blockNumber = block.getAttribute('data-block');
                    const sectionNumber = section.querySelector('.section-image').getAttribute('data-section');
                    
                    // 対応する画像をアクティブにする
                    images.forEach(img => {
                        img.classList.remove('active');
                        if (img.getAttribute('data-block') === blockNumber && 
                            img.getAttribute('data-section') === sectionNumber) {
                            img.classList.add('active');
                        }
                    });
                    
                    // ブロックにアニメーションクラスを追加
                    block.classList.add('visible');

                }
            });
        }, observerOptions);
        
        // 各ブロックを監視対象に追加
        blocks.forEach(block => {
            blockObserver.observe(block);
        });
    });
    
    // スムーズスクロールの実装
    document.querySelectorAll('a[href^="#"]').forEach(anchor => {
        anchor.addEventListener('click', function (e) {
            e.preventDefault();
            const target = document.querySelector(this.getAttribute('href'));
            if (target) {
                target.scrollIntoView({
                    behavior: 'smooth',
                    block: 'start'
                });
            }
        });
    });

    
    // ページ読み込み時の初期化
    const firstBlocks = document.querySelectorAll('.block[data-block="1"]');
    firstBlocks.forEach(block => {
        block.classList.add('visible');
    });
    
    // リサイズ時の処理
    window.addEventListener('resize', function() {
        // モバイル表示の場合は画像を即座に表示
        if (window.innerWidth <= 768) {
            document.querySelectorAll('.section-image').forEach(img => {
                img.style.opacity = '1';
                img.style.transform = 'scale(1)';
            });
        }
    });

    // scroll-fadein クラスのフェードインアニメーション
    const fadeElements = document.querySelectorAll('.scroll-fadein');
    
    const fadeObserver = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                entry.target.classList.add('visible');
            }
        });
    }, {
        threshold: 0.3,
        rootMargin: '0px 0px -100px 0px'
    });
    
    fadeElements.forEach(element => {
        fadeObserver.observe(element);
    });
    
});
